import rem from '@/utils/rem'
import classname from 'classnames'
import InputWithTooltipPlaceholder from '../EForm/FormField/InputWithTooltipPlaceholder';

const Input = ({ id, name, register, type="text", disabled=false, error, placeholder, validation, errorMessage, label, sizing = 'default', maxWidth, prefix, addClass, ...inputProps }) => {

	const sizingOptions = {
		DEFAULT: 'default',
		MEDIUM: 'medium'
	}

	const inputStyles = {
		maxWidth: rem(maxWidth)
	}

	const inputClass = classname(
		addClass,
		{
			'input-field': true,
			'input-field--disabled': disabled,
			'input-field--successful': validation,
			'input-field--error': error,
			'input-field--prefix': prefix,
			'input-field--medium': sizing === sizingOptions.MEDIUM
		}
	)

	const ValidateError = () => {
		//Custom setError message is an object
		if(error && errorMessage?.message) {
			return (
				<span className='t--required'>{errorMessage.message}</span>
			)
		}

		if (error) {
			return (
				<span className='t--required'>{errorMessage}</span>
			)
		}

		return (
			<></>
		)
	}

	return (
		<div className={inputClass} style={inputStyles}>
			{prefix && (
				<span className='input-field__prefix'>{prefix}</span>
			)}
			{label && (
				<label className='input-field__label' htmlFor={name}>{label}</label>
			)}
			<div className='input-field__input'>
				<InputWithTooltipPlaceholder
					id={id || name}
					name={name}
					type={type}
					placeholder={placeholder}
					ref={register}
					disabled={disabled}
					{...inputProps}
				/>
			</div>
			<ValidateError/>
		</div>
	)
}

export default Input
